import React, { useState } from "react";
import VerifyAtmCardStatus from "./VerifyAtmCardStatus";
import UpdateAtmCardStatus from "./UpdateAtmCardStatus";
import { handlePostRequest } from "../../services/PostTemplate";

function AtmCardStatus() {
    const [cardStatus, setCardStatus] = useState(null);
    const [cardNumber, setCardNumber] = useState(null);

    const handleReturnData = (data, cardNumber) => {
        if (data && cardNumber) {
            setCardStatus(data?.data?.Body?.Response?.Status);
            setCardNumber(cardNumber);
        }
        else {
            setCardStatus(null);
            setCardNumber(null);
        }
    };

    const onUpdateStatus = async (status) => {
        const data = {
            cardNumber: cardNumber,
            status: status,
        };
        try {
            await handlePostRequest(data, "zbizgateway/accountMaintainence/updateCardStatus");
            setCardStatus(null);
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <div>
            <VerifyAtmCardStatus title="Update ATM Card Status" api="zbizgateway/accountMaintainence/atmCardStatus" handleReturnData={handleReturnData} />
            {
                cardStatus && cardNumber && (<UpdateAtmCardStatus onUpdateStatus={onUpdateStatus} cardStatus={cardStatus} />)
            }
        </div>
    );
}

export default AtmCardStatus;
